export const VIEWS_COMPONENTS_TRANSLATION_NAMESPACE = "views-components";

export const POS_TK = "POS_TK";
export const CHANNEL_MAPPING_TK = "CHANNEL_MAPPING_TK";
